import Component from './Validation.vue';

export default Component;
